import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { setShowTitleRedirectPopup } from "../../redux/features/dataSlice";

const PopupTitleRedirect = (props) => {
  const { title, search } = props;
  const { showTitleRedirect, academiaSearch } = useSelector(
    (state) => state.data
  );
  const dispatch = useDispatch();
  const [lineWidth, setLineWidth] = useState(35); // Initial line width

  useEffect(() => {
    if (showTitleRedirect.popup && lineWidth < 0) {
      dispatch(setShowTitleRedirectPopup({ popup: false }));
    }
  }, [lineWidth, showTitleRedirect.popup, dispatch]);

  useEffect(() => {
    if (showTitleRedirect.popup) {
      const interval = setInterval(() => {
        setLineWidth((prevWidth) => prevWidth - 7); // Reduce line width by 20 every second
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [showTitleRedirect.popup]);

  return (
    showTitleRedirect.popup && (
      <div className="popup-title-redirect">
        <div>
          <div className="popup-card ml-1">
            <p className="">
              Want to open a full page of results?{" "}
              <span
                className="url"
                onClick={() => {
                  window.open(
                    `/category/${title}/${encodeURIComponent(search)}${
                      title === "Academia" ? `?type=${academiaSearch}` : ""
                    }`,
                    "_blank"
                  );
                }}
              >
                Click here.
              </span>
            </p>
            <CloseIcon
              className="cross"
              onClick={() => {
                dispatch(setShowTitleRedirectPopup({ popup: false }));
              }}
            />
          </div>
          <div className="line" style={{ width: `${lineWidth}rem` }} />
        </div>
      </div>
    )
  );
};

export default PopupTitleRedirect;
